module.exports = __webpack_public_path__ + "img/feature_voice.fbbdfc29.png";